import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import { ExperienceErrorBoundary } from '@/components/primitive/error-boundary';
import { PrimaryType } from '@/meta';
import { spaceTopComfortable } from '@/styles';

import SLOFilterBar from '../slo-filter-bar';
import SearchListBasicCard from '../search/search-results/search-list-cards/search-list-basic-card';

type CapabilityListAdvancedProps = { entityType: PrimaryType | undefined; experienceSeq: number };

const CapabilityListAdvanced: FC<CapabilityListAdvancedProps> = ({ entityType, experienceSeq }) => {
  const { publicId: publicIdParam } = useParams<{ publicId: string }>();
  const publicId = publicIdParam ?? '';

  if (!entityType) return <></>;

  return (
    <ExperienceErrorBoundary>
      <div>
        <SLOFilterBar />
        <div css={spaceTopComfortable}>
          <SearchListBasicCard type={entityType} id={publicId} experienceSeq={experienceSeq} />
        </div>
      </div>
    </ExperienceErrorBoundary>
  );
};

export default CapabilityListAdvanced;
